export default "__VITE_ASSET__DDX8tTR3__";